<template>
  <section id="head">
    <b-navbar toggleable="lg" type="light" fixed="top" class="app-navbar">
      <div class="navbar-left-group">
        <b-navbar-brand
          v-if="typeof(brandHref) === 'string' && brandName"
          :href="brandHref"
          class="app-navbar__brand"
        >
          <b-img class="app-navbar__mark" :src="brandMark" alt="" />
          <span>{{ brandName }}</span>
        </b-navbar-brand>
        <b-navbar-brand v-else-if="brandName" :to="brandHref" class="app-navbar__brand">
          <b-img class="app-navbar__mark" :src="brandMark" alt="" />
          <span>{{ brandName }}</span>
        </b-navbar-brand>

        <subaccount-switch v-if="customerAccounts && customerAccounts.subaccounts && customerAccounts.subaccounts.length" />
      </div>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav @click="itemClicked(navItem)" v-for="(navItem, key) in navItems" :key="key">
          <b-nav-item :to="navItem.href" :class="{ 'app-navbar__item--logout': isLogout(navItem) }">
            <div class="d-flex">
              {{ navItem.text }}
              <b-badge
                v-if="navItem.badgeText"
                class="align-self-baseline ml-1 app-navbar__badge"
                :variant="navItem.badgeVariant"
              >
                {{ navItem.badgeText }}
              </b-badge>
            </div>
          </b-nav-item>
        </b-navbar-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <languages-menu />
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </section>
</template>

<script>
  import LanguagesMenu from '@base/components/LanguagesMenu.vue'
  import SubaccountSwitch from '@user/components/SubaccountSwitch.vue'
  import { mapState } from 'vuex'
  import { IS_GLOBAL_APP } from '@base/configs'

  export default {
    name: 'NavBar',

    components: {
      LanguagesMenu,
      SubaccountSwitch
    },

    props: {
      brandName: {
        type: String,
      },
      brandHref: {
        default () {
          return { name: 'base' }
        }
      },
      navItems: {
        type: Array,
        required: false
      }
    },

    computed: {
      ...mapState(['customerAccounts']),

      brandMark () {
        return IS_GLOBAL_APP
          ? require('@base/assets/images/flealover-mark.png')
          : require('@base/assets/images/loppeonline-mark.png')
      },
    },

    methods: {
      itemClicked (navItem) {
        this.$emit('itemClicked', navItem)
      },

      isLogout (navItem) {
        return navItem.text === this.$t('navigation.general.logout')
      },
    }
  }
</script>

<style scoped>
  .app-navbar {
    background: #fff;
    border-bottom: 1px solid var(--ui-border);
  }

  .navbar-left-group {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .app-navbar__brand {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: var(--ui-ink);
    font-weight: 600;
  }

  .app-navbar__brand:hover {
    color: var(--ui-ink);
  }

  .app-navbar__mark {
    width: 26px;
    height: 26px;
    object-fit: contain;
  }

  .app-navbar ::v-deep .nav-link {
    color: var(--ui-muted);
    font-weight: 500;
    position: relative;
  }

  .app-navbar ::v-deep .nav-link:hover,
  .app-navbar ::v-deep .nav-link.router-link-active {
    color: var(--ui-ink);
  }

  .app-navbar__badge {
    border-radius: 10rem;
    margin-top: -6px;
  }

  @media (min-width: 992px) {
    .app-navbar ::v-deep .nav-link.router-link-active::after {
      content: '';
      position: absolute;
      left: 0.5rem;
      right: 0.5rem;
      bottom: -0.5rem;
      height: 2px;
      border-radius: 2px;
      background: var(--ui-brand);
    }

    .app-navbar__item--logout {
      margin-left: 0.75rem;
    }
  }

  @media (max-width: 991.98px) {
    .app-navbar ::v-deep .navbar-collapse .nav-link {
      padding: 0.75rem 0;
      border-bottom: 1px solid var(--ui-border);
    }
  }
</style>
